import type {MineralId, MineralLabel, RegionLabel, SourceKey} from './types';

/**
 * RSS API origin (no trailing slash). Used for login, `POST /rss/add_post`, and image URLs.
 * Default is HTTP — local Nest (`nest start`) serves plain HTTP on port 5000; HTTPS here causes
 * `ERR_SSL_PROTOCOL_ERROR`. Set `REACT_APP_RSS_API_URL=https://your-api.example.com` in production.
 */
export const RSS_API_URL = (process.env.REACT_APP_RSS_API_URL || 'http://localhost:5000').replace(
  /\/$/,
  ''
);

export const RSS_ADD_POST_URL = `${RSS_API_URL}/rss/add_post`;

export const RSS_GET_POSTS_URL = `${RSS_API_URL}/rss/get_posts`;

export const RSS_GET_ALL_POSTS_URL = `${RSS_API_URL}/rss/get_all_posts`;

export const FETCH_RSS_URL = `${RSS_API_URL}/rss/latest`;

/** `DELETE /rss/delete_post/:id` — id must be the numeric server post id. */
export function rssDeletePostUrl(id: string): string {
  return `${RSS_API_URL}/rss/delete_post/${encodeURIComponent(id)}`;
}

export const MINERALS: Array<{
  id: MineralId;
  label: MineralLabel;
  icon: string;
  color: string;
  tc: string;
  cc: string;
}> = [
  {id: 'li', label: 'Lithium', icon: '⚡', color: '#2563eb', tc: 'tm-li', cc: 'chip-li'},
  {id: 'co', label: 'Cobalt', icon: '🔵', color: '#7c3aed', tc: 'tm-co', cc: 'chip-co'},
  {id: 'ni', label: 'Nickel', icon: '🟢', color: '#059669', tc: 'tm-ni', cc: 'chip-ni'},
  {id: 'cu', label: 'Copper', icon: '🟠', color: '#ea580c', tc: 'tm-cu', cc: 'chip-cu'},
  {id: 're', label: 'REE', icon: '💎', color: '#be123c', tc: 'tm-re', cc: 'chip-re'},
  {id: 'gr', label: 'Graphite', icon: '⬛', color: '#374151', tc: 'tm-gr', cc: 'chip-gr'},
  {id: 'au', label: 'Gold', icon: '🟡', color: '#ca8a04', tc: 'tm-au', cc: 'chip-au'},
  {id: 'si', label: 'Silver', icon: '⚪', color: '#64748b', tc: 'tm-si', cc: 'chip-si'},
  {id: 'zn', label: 'Zinc', icon: '🔷', color: '#0891b2', tc: 'tm-zn', cc: 'chip-zn'},
  {id: 'mn', label: 'Manganese', icon: '🔴', color: '#dc2626', tc: 'tm-mn', cc: 'chip-mn'},
  {id: 'gen', label: 'General', icon: '⛏', color: '#78716c', tc: 'tm-gen', cc: 'chip-gen'},
];

export const REGIONS: RegionLabel[] = ['Asia', 'Africa', 'Americas', 'Europe', 'Australia', 'Global'];

export const RSS_FEEDS: Array<{ name: Exclude<SourceKey, 'gdelt'>; url: string; label: string }> = [
  {name: 'mining.com', url: 'https://www.mining.com/feed/', label: 'Mining.com'},
  // {name: 'miningwkly', url: 'https://www.miningweekly.com/page/home/feed', label: 'Mining Weekly'},
  // {name: 'im-mining', url: 'https://im-mining.com/feed/', label: "Int'l Mining"},
  // {name: 'emj', url: 'https://www.e-mj.com/feed/', label: 'E&MJ'},
  // {name: 'canadianmj', url: 'https://canadianminingjournal.com/feed/', label: 'Canadian MJ'},
];

export const COUNTRY_LL: Record<string, [number, number]> = {
  india: [20.5, 78.9],
  australia: [-25.3, 133.7],
  china: [35.8, 104.1],
  'united states': [37.1, -95.7],
  canada: [56.1, -106.3],
  brazil: [-14.2, -51.9],
  'south africa': [-30.5, 22.9],
  congo: [-4.0, 21.7],
  chile: [-35.6, -71.5],
  indonesia: [-0.8, 113.9],
  russia: [61.5, 105.3],
  peru: [-9.1, -75.0],
  argentina: [-38.4, -63.6],
  mexico: [23.6, -102.5],
  germany: [51.1, 10.4],
  uk: [55.3, -3.4],
  france: [46.2, 2.2],
  japan: [36.2, 138.2],
  zambia: [-13.1, 27.8],
  zimbabwe: [-20.0, 30.0],
  ghana: [7.9, -1.0],
  namibia: [-22.9, 18.4],
  tanzania: [-6.3, 34.8],
  kenya: [0.0, 37.9],
  nigeria: [9.1, 8.7],
  morocco: [31.8, -7.1],
  mongolia: [46.8, 103.8],
  kazakhstan: [48.0, 68.0],
  sweden: [62.0, 15.0],
};

export const PAGE_SZ = 12;

// Controls automatic refresh + countdown.
export const REFRESH_SECONDS = 60;

